export class LegalInstrument {
  constructor({ alias, id, title } = {}) {
    this.alias = alias;
    this.id = id;
    this.title = title;
  }
}
